import script from "./C4Mailbox.vue?vue&type=script&setup=true&lang=js"
export * from "./C4Mailbox.vue?vue&type=script&setup=true&lang=js"

import "./C4Mailbox.vue?vue&type=style&index=0&id=7e44a499&lang=scss"

const __exports__ = script;

export default __exports__